import React from "react";
import { TrainingIcon } from "../TrainingIcon";
import { SEGMENT_DISPLAY_LABELS } from "../../constants/trainingConstants";

const PrincipleComplianceMatrix = ({
  mockData,
  title = "Principle Compliance Matrix (P1-P9) - Employee Coverage"
}) => {
  if (!mockData || !mockData.trainingPrograms || !mockData.principles) {
    return (
      <div className="trd-section">
        <div className="trd-empty">No data available</div>
      </div>
    );
  }

  return (
    <div className="trd-section">
      <div className="trd-section-head">
        <span className="trd-section-icon"><TrainingIcon name="target" size={18} /></span>
        <div>
          <h2 className="trd-section-title">{title}</h2>
        </div>
      </div>

      <div className="trd-table-wrap">
        <table className="trd-table">
          <thead>
            <tr>
              <th className="trd-th-label">Principle</th>
              {Object.entries(mockData.trainingPrograms).map(([category, program]) => (
                <th key={category}>
                  <div>{SEGMENT_DISPLAY_LABELS[category] || category}</div>
                  <span className="trd-th-sub">Total: {program.totalEmployees}</span>
                </th>
              ))}
            </tr>
            <tr>
              <th className="trd-th-label"></th>
              {Object.keys(mockData.trainingPrograms).map((category) => (
                <th key={category}>No. Covered | %</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Object.entries(mockData.principles).map(([principleKey, principleDescription]) => (
              <tr key={principleKey} className="trd-tr">
                <td className="trd-td-label">
                  <div className="trd-principle-key">{principleKey}</div>
                  <div className="trd-principle-desc">{principleDescription}</div>
                </td>
                {Object.entries(mockData.trainingPrograms).map(([category, program]) => {
                  const compliance = program.principleCompliance[principleKey];
                  const isCompliant = compliance.status === "Yes";
                  const totalEmployees = program.totalEmployees;
                  const coverageRaw = (compliance.covered / totalEmployees) * 100;
                  const coveragePercentage = isNaN(coverageRaw) ? 0 : coverageRaw.toFixed(1);

                  return (
                    <td key={category}>
                      <div className={`trd-cell ${isCompliant ? "trd-cell--yes" : "trd-cell--no"}`}>
                        <span className="trd-cell-status">{compliance.status}</span>
                        <div>
                          <span className="trd-cell-num">{compliance.covered}</span>
                          <span className="trd-sep">|</span>
                          <span className="trd-cell-num">{compliance.percentage}%</span>
                        </div>
                        <div className="trd-cell-hint">{coveragePercentage}% coverage</div>
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PrincipleComplianceMatrix;
